import script from "./CallingView.vue?vue&type=script&setup=true&lang=js"
export * from "./CallingView.vue?vue&type=script&setup=true&lang=js"

import "./CallingView.vue?vue&type=style&index=0&id=9d89737e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d89737e"]])

export default __exports__